import React from 'react'
import { CSVLink } from 'react-csv'

export const CSV = ({ fileName = 'file.csv', csvData = [], text = 'Download file' }) => (<CSVLink
    data={csvData}
    filename={fileName}
    className="btn btn-primary"
    target="_blank"
>
    {text}
</CSVLink>)